import { Spinner } from "@medusajs/icons";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../../hooks/api/auth";
import { useSessionTimeout } from "../../../hooks/use-session-timeout";
import { SearchProvider } from "../../../providers/search-provider";
import { SidebarProvider } from "../../../providers/sidebar-provider";
import { AuthGuard } from "../../common/auth-guard";

export const ProtectedRoute = () => {
  const { user, isLoading, isAuthenticated } = useAuth();
  const location = useLocation();

  useSessionTimeout();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="text-ui-fg-interactive animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <SidebarProvider>
      <SearchProvider>
        <AuthGuard>
          <Outlet />
        </AuthGuard>
      </SearchProvider>
    </SidebarProvider>
  );
};
